<template>
  <b-container fluid class="sidebar-container">
    <b-row no-gutters>
      <b-col
        cols="12"
        :class="['sidebar-col', { 'mb-4': index < sidebarData.length - 1 }]"
        v-for="(sidebar, index) in sidebarData"
        :key="index"
      >
        <div class="sidebar-card">
          <!-- Header -->
          <div class="sidebar-header">
            <span class="sidebar-category">{{ sidebar.categoria }}</span>
          </div>

          <!-- Carousel for multiple items -->
          <b-carousel
            v-if="sidebar.elementoSidebars.length > 1"
            controls
            indicators
            class="sidebar-carousel"
            :interval="0"
          >
            <b-carousel-slide
              v-for="(notice, k) in sidebar.elementoSidebars"
              :key="k"
            >
              <template #default>
                <div class="slide-content">
                  <div class="slide-title">{{ notice.titulo }}</div>

                  <div class="slide-image">
                    <a
                      v-if="notice.link && notice.linkEnImagen"
                      :href="notice.link"
                      target="_blank"
                    >
                      <img :src="notice.url" alt="imagen" />
                    </a>
                    <img
                      v-else
                      :src="notice.url"
                      alt="imagen"
                      class="lightbox-trigger"
                      @click="openLightbox(notice.url, notice.titulo)"
                    />

                    <!-- Ver más button positioned over image -->
                    <a
                      v-if="notice.link && !notice.linkEnImagen"
                      :href="notice.link"
                      target="_blank"
                      class="slide-link"
                    >
                      Ver más
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </a>
                  </div>

                  <div
                    v-if="notice.texto"
                    class="slide-text"
                    v-html="notice.texto"
                  ></div>
                </div>
              </template>
            </b-carousel-slide>
          </b-carousel>

          <!-- Single item -->
          <div v-else class="single-content">
            <div class="slide-title">
              {{ sidebar.elementoSidebars[0].titulo }}
            </div>

            <div class="slide-image">
              <a
                v-if="
                  sidebar.elementoSidebars[0].link &&
                  sidebar.elementoSidebars[0].linkEnImagen
                "
                :href="sidebar.elementoSidebars[0].link"
                target="_blank"
              >
                <img :src="sidebar.elementoSidebars[0].url" alt="imagen" />
              </a>
              <img
                v-else
                :src="sidebar.elementoSidebars[0].url"
                alt="imagen"
                class="lightbox-trigger"
                @click="
                  openLightbox(
                    sidebar.elementoSidebars[0].url,
                    sidebar.elementoSidebars[0].titulo
                  )
                "
              />

              <!-- Ver más button positioned over image -->
              <a
                v-if="
                  sidebar.elementoSidebars[0].link &&
                  !sidebar.elementoSidebars[0].linkEnImagen
                "
                :href="sidebar.elementoSidebars[0].link"
                target="_blank"
                class="slide-link"
              >
                Ver más
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            <div
              v-if="sidebar.elementoSidebars[0].texto"
              class="slide-text"
              v-html="sidebar.elementoSidebars[0].texto"
            ></div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Lightbox Modal -->
    <b-modal
      id="modal-sidebar-photo"
      size="xl"
      centered
      hide-header
      body-bg-variant="transparent"
      content-class="border-0 bg-transparent"
      hide-footer
    >
      <img :src="lightboxImage" class="img-fluid w-100" />
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    sidebarData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lightboxImage: "",
      lightboxTitle: "",
    };
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    template() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.template
        : "default";
    },
  },
  methods: {
    openLightbox(imageUrl, title) {
      this.lightboxImage = imageUrl;
      this.lightboxTitle = title || "";
      this.$root.$emit("bv::show::modal", "modal-sidebar-photo");
    },
  },
};
</script>

<style scoped>
.sidebar-container {
  padding: 0;
}

/* Card */
.sidebar-card {
  background: #f8fafc;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

/* Header */
.sidebar-header {
  padding: 10px 16px;
  background: var(--color-a, #3b82f6);
}

.sidebar-category {
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Content */
.single-content,
.slide-content {
  padding: 12px 16px 16px 16px;
  position: relative;
}

.slide-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 10px;
  line-height: 1.4;
}

.slide-text {
  font-size: 0.8125rem;
  color: #475569;
  line-height: 1.5;
  margin-bottom: 0;
}

.slide-text :deep(p) {
  margin: 0;
}

/* Image with link overlay */
.slide-image {
  margin-bottom: 10px;
  border-radius: 6px;
  overflow: hidden;
  max-height: 180px;
  position: relative;
}

.slide-link {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  background: var(--color-a, #3b82f6);
  padding: 6px 10px;
  border-radius: 6px;
  text-decoration: none;
  transition: opacity 0.2s, transform 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.slide-link:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  text-decoration: none;
  color: white;
}

.slide-link svg {
  width: 12px;
  height: 12px;
}

/* Carousel customization */
.sidebar-carousel {
  background: transparent;
}

.sidebar-carousel :deep(.carousel-inner) {
  overflow: hidden;
}

.sidebar-carousel :deep(.carousel-item) {
  padding: 0;
}

.sidebar-carousel :deep(.carousel-caption) {
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0;
  text-align: left;
  color: inherit;
}

.sidebar-carousel :deep(.img-fluid) {
  display: none;
}

/* Image constraints */
.slide-image {
  margin-bottom: 10px;
  border-radius: 6px;
  overflow: hidden;
  max-height: 180px;
}

.slide-image img {
  width: 100%;
  height: 100%;
  max-height: 180px;
  object-fit: cover;
  display: block;
}

.sidebar-carousel :deep(.carousel-control-prev),
.sidebar-carousel :deep(.carousel-control-next) {
  position: absolute;
  width: 24px;
  height: 24px;
  top: auto;
  bottom: 3px;
  transform: none;
  background: var(--color-btn, #3b82f6);
  border-radius: 50%;
  opacity: 0.9;
  z-index: 15;
}

.sidebar-carousel :deep(.carousel-control-prev) {
  left: 16px;
  right: auto;
}

.sidebar-carousel :deep(.carousel-control-next) {
  right: 16px;
  left: auto;
}

.sidebar-carousel :deep(.carousel-control-prev-icon),
.sidebar-carousel :deep(.carousel-control-next-icon) {
  width: 10px;
  height: 10px;
}

.sidebar-carousel :deep(.carousel-indicators) {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
  margin: 12px 0 12px 0;
  padding: 0 50px;
  height: 24px;
  z-index: 10;
  pointer-events: none;
}

.sidebar-carousel :deep(.carousel-indicators li) {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
  border: none;
  margin: 0 4px;
  pointer-events: auto;
}

.sidebar-carousel :deep(.carousel-indicators li.active) {
  background: var(--color-btn, #3b82f6);
}

/* Lightbox Styles */
.lightbox-trigger {
  cursor: zoom-in;
  transition: opacity 0.2s;
}

.lightbox-trigger:hover {
  opacity: 0.9;
}

/* Responsive Styles */
@media (max-width: 1024px) {
  .sidebar-container {
    padding: 0;
    width: 100%;
  }

  .sidebar-container :deep(.row) {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
  }

  .sidebar-col {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .sidebar-card {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .sidebar-card {
    border-radius: 24px;
  }

  .sidebar-header {
    padding: 8px 14px;
  }

  .sidebar-category {
    font-size: 0.8rem;
  }

  .single-content,
  .slide-content {
    padding: 10px 14px 14px 14px;
  }

  .slide-title {
    font-size: 0.875rem;
    margin-bottom: 8px;
  }

  .slide-text {
    font-size: 0.75rem;
  }

  .slide-image {
    max-height: 160px;
    margin-bottom: 8px;
  }

  .slide-image img {
    max-height: 160px;
  }

  .slide-link {
    font-size: 0.7rem;
    padding: 5px 8px;
    bottom: 6px;
    right: 6px;
  }

  .slide-link svg {
    width: 10px;
    height: 10px;
  }

  .sidebar-carousel :deep(.carousel-control-prev),
  .sidebar-carousel :deep(.carousel-control-next) {
    width: 20px;
    height: 20px;
    bottom: 2px;
  }

  .sidebar-carousel :deep(.carousel-control-prev) {
    left: 12px;
  }

  .sidebar-carousel :deep(.carousel-control-next) {
    right: 12px;
  }

  .sidebar-carousel :deep(.carousel-control-prev-icon),
  .sidebar-carousel :deep(.carousel-control-next-icon) {
    width: 8px;
    height: 8px;
  }

  .sidebar-carousel :deep(.carousel-indicators) {
    margin: 10px 0 10px 0;
    height: 20px;
    padding: 0 40px;
  }

  .sidebar-carousel :deep(.carousel-indicators li) {
    width: 6px;
    height: 6px;
    margin: 0 3px;
  }
}

@media (max-width: 576px) {
  .sidebar-col.mb-4 {
    margin-bottom: 12px !important;
  }

  .sidebar-card {
    border-radius: 20px;
  }

  .sidebar-header {
    padding: 6px 12px;
  }

  .sidebar-category {
    font-size: 0.75rem;
    letter-spacing: 0.3px;
  }

  .single-content,
  .slide-content {
    padding: 8px 12px 12px 12px;
  }

  .slide-title {
    font-size: 0.8125rem;
    margin-bottom: 6px;
  }

  .slide-text {
    font-size: 0.7rem;
    line-height: 1.4;
  }

  .slide-image {
    max-height: 140px;
    border-radius: 4px;
  }

  .slide-image img {
    max-height: 140px;
  }

  .slide-link {
    font-size: 0.65rem;
    padding: 4px 6px;
    gap: 3px;
    border-radius: 4px;
  }
}

@media (max-width: 375px) {
  .slide-image {
    max-height: 120px;
  }

  .slide-image img {
    max-height: 120px;
  }

  .slide-title {
    font-size: 0.75rem;
  }
}
</style>
